// NOTICE: KAPTION-INTEGRATION
// home-dashboard-app.WEB.7 — the current user's home app in the current
// account for this surface (desktop inside Rumo Desktop, otherwise web), or
// null. Prefers the account record (GET accounts/:id, refreshed after an admin
// saves the Home screen settings) and falls back to the profile's accounts[].
import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import { useAccount } from 'dashboard/composables/useAccount';
import {
  currentHomeSurface,
  getUserHomeAppId,
  homeAppIdFrom,
} from 'dashboard/helper/kaptionHomeApp';

export function useKaptionHomeApp() {
  const { accountId, currentAccount } = useAccount();
  const currentUser = useMapGetter('getCurrentUser');

  const homeAppId = computed(() => {
    const surface = currentHomeSurface();
    const fromAccount = currentAccount.value?.home_dashboard_apps;
    if (fromAccount) return homeAppIdFrom(fromAccount, surface);
    return getUserHomeAppId(currentUser.value, accountId.value, surface);
  });

  return { homeAppId };
}
